<template>
  <div id="residentOpen">
    <filter-frame
      ref="filter"
      :save-filter="true"
      :filter-form="depositFilter"
      @search="search"
      @clear="clearSearch()"
    />
    <div
      v-if="deviceOpenedRate"
      class="center-block"
    >
      <span>對講機開通率：{{ deviceOpenedRate }}%</span>
      <div style="margin-left: auto;">
        <el-button
          v-if="contract.partialSale"
          round
          @click="$store.commit('intercom/triggerAuthorizedDialog', true)"
        >
          編輯授權名單
        </el-button>
        <el-button
          round
          @click="importNumberDialogVisible = true"
        >
          匯入市話轉接號碼
        </el-button>
        <span style="margin-left:10px">共 {{ totalTablet }} 筆資料</span>
      </div>
    </div>
    <el-table
      v-horizontal-scroll="'always'"
      class="newslist"
      :data="ListData"
      empty-text="目前無任何住戶開通"
      row-key="TabletId"
      :indent="50"
    >
      <!-- 這一個cell只是給上下折疊箭頭留的空間 -->
      <el-table-column
        prop="IsOpened"
        label=""
        width="33"
      >
        <template slot-scope="scope">
          <!-- element ui對於沒有子層的欄位不會有icon，我們需求要，所以補上去-->
          <div
            v-if="!scope.row.ParentId && !scope.row.children && typeof filter.type !== 'boolean'"
            class="el-table__expand-icon"
          >
            <i class="el-icon-arrow-right icon-disable" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="IsOpened"
        label="對講機開通"
        width="120"
        sortable
      >
        <template slot-scope="scope">
          <span :class="scope.row.IntercomTotal > 0 ? 'text-opened' : 'text-notOpened'">
            {{ scope.row.IsOpened }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="contract.partialSale"
        prop="IsAuthorized"
        label="授權狀態"
        width="120"
        sortable
      >
        <template slot-scope="scope">
          <span :class="scope.row.IsAuthorized ? 'is-authorized' : 'not-authorized'">{{ scope.row.IsAuthorized ? '已授權' : '未授權' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Tag"
        label="棟別"
        width="150"
        sortable
      />
      <el-table-column
        prop="TabletNote"
        label="戶別"
        min-width="200"
        sortable
      />
      <el-table-column
        prop="IsVirtual"
        label="戶別類型"
        width="120"
        sortable
      >
        <template slot-scope="scope">
          {{ scope.row.IsVirtual ? '承租戶' : '區權戶' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="VirtualUsername"
        label="對講機號碼"
        width="150"
        sortable
      >
        <template slot-scope="scope">
          {{ scope.row.VirtualUsername || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="TransferNumber"
        width="150"
      >
        <template #header>
          <span>市話轉接號碼</span>
          <span style="margin-left: 3px;">
            <el-tooltip placement="top">
              <div slot="content">
                您的社區{{ contract.callForwarding ? '已' : '尚未' }}啟用「市話轉接加值服務」，在此為戶別設定轉接號碼，<br>
                住戶對講機App未接時，將可以為您轉接到指定的市話或手機號碼。
              </div>
              <i :class="contract.callForwarding ? 'icon-check-circle' : 'icon-filled-info'" />
            </el-tooltip>
          </span>
        </template>
        <template slot-scope="scope">
          <div>
            <span
              class="transfer-number"
              @click="openTransferNumberDialog(scope.row.CommunitySubscriberId, scope.row.CellPhoneData, scope.row.LandlineData, scope.row.TabletId)"
            >
              <template v-if="scope.row.CellPhoneData">{{ scope.row.CellPhoneData.PhoneNumber }}</template>
              <template v-else-if="scope.row.LandlineData">
                {{ scope.row.LandlineData.AreaCode }}-{{ scope.row.LandlineData.LandlineNumber }}
              </template>
              <template v-else>
                新增轉接號碼
              </template>
            </span>
            <span
              v-if="scope.row.CellPhoneData || scope.row.LandlineData"
              class="delete-transfer-number"
              @click="deleteTransferNumber(scope.row.TabletId)"
            >
              <i class="icon-delete" />
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="Total"
        label="智生活APP裝置數"
        width="170"
        sortable
      />
      <el-table-column
        label="操作"
        width="120"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            @click="openDetailDialog(scope.row.TabletId)"
          >
            裝置明細
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="loading" />
    <el-dialog
      :title="$t('Intercom.DeviceDetails')"
      :visible.sync="detailDialogVisible"
      width="50%"
    >
      <div class="devices-table-title">
        {{ $t('Intercom.PrivateHardware') }}（{{ VoipDeviceListData ? VoipDeviceListData.length : 0 }}）
      </div>
      <el-table
        class="newslist"
        :data="VoipDeviceListData"
        :empty-text="$t('Intercom.DeviceDetailsEmpty')"
      >
        <el-table-column
          type="index"
          width="50"
        />
        <el-table-column
          prop="Area"
          :label="$t('Intercom.PrivateHardwareArea')"
        />
        <el-table-column
          prop="Category"
          :label="$t('Intercom.PrivateHardwareCategory')"
        />
        <el-table-column
          prop="Model"
          :label="$t('Intercom.PrivateHardwareModel')"
        />
      </el-table>
      <div class="devices-table-title" style="margin-top: 32px">
        {{ $t('Intercom.AppDevice') }}（{{ DeviceListData ? DeviceListData.length : 0 }}）
      </div>
      <el-table
        class="newslist"
        :data="DeviceListData"
        :empty-text="$t('Intercom.DeviceDetailsEmpty')"
      >
        <el-table-column
          type="index"
          width="50"
        />
        <el-table-column
          prop="Device"
          label="裝置系統"
        />
        <el-table-column
          prop="Model"
          label="裝置型號"
        >
          <template slot-scope="scope">
            {{ getDeviceModel(scope.row.Model) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="Version"
          label="裝置版本"
        />
        <el-table-column
          prop="CreateAt"
          label="開通時間"
        >
          <template slot-scope="scope">
            {{
              scope.row.CreateAt
                ? `${scope.row.CreateAt.split(':')[0]}:${scope.row.CreateAt.split(':')[1]}`
                : ''
            }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :visible.sync="transferNumberDialogVisible"
      :close-on-click-modal="false"
      center
      @close="closeTransferNumberDialog"
    >
      <div slot="title">
        <p class="dialog-title">
          設定轉接號碼
        </p>
        <p class="dialog-subTitle">
          ※針對社區戶別設定轉接號碼，App撥號15秒後仍未接時，即自動轉接到設定的市話/手機
        </p>
        <p class="dialog-subTitle">
          ※轉接號碼限定台灣地區之市話與手機號碼
        </p>
      </div>
      <div class="transfer-number-body">
        <el-form
          ref="transferNumberForm"
          :inline="true"
          :rules="transferNumberRules"
          :model="transferNumber"
        >
          <el-form-item prop="type">
            <el-select
              v-model="transferNumber.type"
              placeholder="請選擇號碼類型"
            >
              <el-option
                value="tel"
                label="市話"
              />
              <el-option
                value="phone"
                label="手機號碼"
              />
            </el-select>
          </el-form-item>
          <template v-if="transferNumber.type === 'tel'">
            <el-form-item prop="areaNumber">
              <el-input
                v-model="transferNumber.areaNumber"
                maxlength="4"
                type="tel"
                placeholder="02"
                class="area-number"
                prop="area"
              />
            </el-form-item>
            <span>-</span>
            <el-form-item prop="telNumber">
              <el-input
                v-model="transferNumber.telNumber"
                :maxlength="12 - transferNumber.areaNumber.length"
                type="tel"
                placeholder="4128166"
                class="number"
                prop="tel"
              />
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item prop="phoneNumber">
              <el-input
                v-model="transferNumber.phoneNumber"
                maxlength="10"
                type="tel"
                placeholder="0912345678"
                class="number"
                prop="phone"
                :disabled="transferNumber.type === ''"
              />
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer">
        <el-button
          size="mini"
          plain
          :disabled="transferNumberBtnDisabled"
          @click="confirmTransferNumber"
        >
          確認
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="匯入戶別市話轉接號碼"
      class="import-number-dialog"
      :visible.sync="importNumberDialogVisible"
      width="50%"
      @close="clearNumberFileInput"
    >
      <input
        v-show="false"
        ref="invisibleFileInput"
        type="file"
        accept=".xlsx"
        @change="importNumberFileChange"
      >

      <el-input
        v-model="importNumberFile.name"
        :prefix-icon="importNumberFile.name?'icon-file-paper':''"
      >
        <el-button
          v-if="!importNumberFile.name"
          slot="append"
          class="upload-text"
          @click="$refs.invisibleFileInput.click()"
        >
          上傳檔案
        </el-button>
        <el-button
          v-else
          slot="append"
          class="upload-text"
          @click="importNumberFileRemove"
        >
          移除
        </el-button>
      </el-input>
      <p
        v-if="importNumberFileProgress !== null"
        class="progress-text"
      >
        上傳中 {{ importNumberFileProgress }} %
      </p>
      <div class="button-container">
        <el-button @click="importNumberFileExportForm">
          匯出表單
        </el-button>
        <el-button
          type="primary"
          @click="importNumberFileConfirmUpload"
        >
          確認上傳
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
import filterFrame from '@/components/FilterFrame'
import { getExtensionFromLink, createDownloadFile } from '@/js/utils/index'
import { isValidCellphone } from '@/js/utils/unitValidate'
import { getDeviceModel } from '@/js/models/appleDevice'
import { housekeeperAPI } from '@/api/HousekeeperAPI.js'

export default {
  components: {
    'filter-frame': filterFrame,
    TableLoading
  },
  data () {
    const validateType = (rule, value, callback) => {
      if (value === '') callback(new Error('號碼類型不可為空'))
      else callback()
    }
    const validateArea = (rule, value, callback) => {
      if (value === '') callback(new Error('區碼不可為空'))
      else if (!this.isCorrectAreaNumber(value)) callback(new Error('區碼格式錯誤，請輸入正確區碼'))
      else callback()
    }
    const validateTel = (rule, value, callback) => {
      if (value === '') callback(new Error('市話不可為空'))
      else if (!this.isCorrectTelNumber(value)) callback(new Error('市話格式錯誤，請輸入正確市話'))
      else callback()
    }
    const validatePhone = (rule, value, callback) => {
      if (value === '') callback(new Error('手機號碼不可為空'))
      else if (!this.isCorrectPhone(value)) callback(new Error('手機號碼格式錯誤，請輸入正確手機號碼'))
      else callback()
    }
    return {
      houseList: [],
      filter: {
        tag: null,
        type: null,
        phone: null,
        status: null
      },
      loading: false,
      depositFilter: [
        {
          label: '棟別',
          name: 'tag',
          type: 'select',
          options: [
            {
              label: '請選擇',
              value: ''
            }
          ],
          value: ''
        },
        {
          label: '戶別類型',
          name: 'type',
          type: 'select',
          options: [
            {
              label: '請選擇',
              value: ''
            },
            {
              label: '區權戶',
              value: false
            },
            {
              label: '承租戶',
              value: true
            }
          ],
          value: ''
        },
        {
          label: '對講機號碼',
          name: 'phone',
          type: 'input'
        },
        {
          label: '開通狀況',
          name: 'status',
          type: 'select',
          options: [
            {
              label: '請選擇',
              value: ''
            },
            {
              label: '已開通',
              value: true
            },
            {
              label: '未開通',
              value: false
            }
          ],
          value: ''
        }
      ],
      ListData: [],
      DeviceListData: [],
      VoipDeviceListData: [],
      detailDialogVisible: false,
      transferNumberDialogVisible: false,
      deviceOpenedRate: null,
      transferNumberRules: {
        type: [
          { validator: validateType, trigger: 'blur' }
        ],
        areaNumber: [
          { validator: validateArea, trigger: 'blur' }
        ],
        telNumber: [
          { validator: validateTel, trigger: 'blur' }
        ],
        phoneNumber: [
          { validator: validatePhone, trigger: 'blur' }
        ]
      },
      transferNumber: {
        id: '',
        type: '',
        areaNumber: '',
        telNumber: '',
        phoneNumber: ''
      },
      contract: {
        callForwarding: false,
        partialSale: false // 是否支援部分銷售
      },
      // 匯入戶別市話轉接號碼
      importNumberDialogVisible: false,
      importNumberFile: { name: '' }, // 此變數default為此，勿給空物件
      importNumberFileProgress: null, // 上傳進度，null為不顯示(沒有在上傳)
      totalTablet: 0,
      getDeviceModel
    }
  },
  computed: {
    transferNumberBtnDisabled () {
      if (this.transferNumber.type === '') return true
      if (
        this.transferNumber.type === 'tel' &&
        (this.transferNumber.areaNumber === '' || !this.isCorrectAreaNumber(this.transferNumber.areaNumber) ||
          this.transferNumber.telNumber === '' || !this.isCorrectTelNumber(this.transferNumber.telNumber))
      ) return true
      if (this.transferNumber.type === 'phone' && (this.transferNumber.phoneNumber === '' || !this.isCorrectPhone(this.transferNumber.phoneNumber))) return true
      return false
    },
    isOverAuthorized () {
      return this.authorizedHousehold.length > this.contract.authorizedTabletsTotalNum
    }
  },
  watch: {
    'transferNumber.type' () {
      this.$refs.transferNumberForm.clearValidate()
    },
    '$store.state.intercom.isOpenAuthorizedDialog': {
      handler: function (newVal, oldVal) {
        // dialog被關掉時重新取個資料
        if (!newVal) {
          this.getList()
        }
      }
    }
  },
  async mounted () {
    vuecp.news = this
    this.getComTag()
    this.getContract()
    await this.getList()
    this.getdeviceOpenedRate() // 要等getList打完才能打
    this.addPartialSaleFilter() // 若提供部分銷售，則需增加一個「授權狀態」filter
  },
  methods: {
    // 取得棟別
    async getComTag () {
      const { data } = await housekeeperAPI.getCommunityTabletTag()
      try {
        this.houseList = data.Data.Tags
        this.depositFilter[0].options = this.depositFilter[0].options.concat(this.houseList.map(item => {
          return {
            label: item.Tag,
            value: item.Tag
          }
        }))
      } catch (err) {
        this.$message({
          message: this.$t('Household.GetBuildingFailed'),
          type: 'warning'
        })
        console.log(err.response)
      }
    },
    async getContract () {
      try {
        await this.$store.state.intercom.contractPromise // 等待合約資料讀取完成
        this.contract.callForwarding = this.$store.getters['intercom/hasCallForwarding']
        // 是否有部分銷售合約，會影響授權狀態等資訊是否顯示
        this.contract.partialSale = this.$store.getters['intercom/hasPartialSale']
      } catch (err) {
        console.log(err)
      }
    },
    // 查詢
    search (such_val) {
      console.log(such_val)
      this.filter = {
        tag: such_val.tag,
        type: such_val.type,
        phone: such_val.phone,
        status: such_val.status,
        isAuthorized: such_val.isAuthorized
      }
      this.ListData = []
      this.getList()
    },
    // 清除條件
    clearSearch () {
      this.filter = {
        tag: null,
        type: null,
        phone: null,
        status: null
      }
      this.ListData = []
      this.offset = 0
      window.scrollTo(0, 0)
      this.getList()
    },
    // 取得住戶開通列表
    async getList () {
      this.loading = true
      const params = {
        Tag: this.filter.tag,
        IsVirtual: this.filter.type,
        VirtualUsername: this.filter.phone,
        HasIntercom: this.filter.status,
        IsAuthorized: this.filter.isAuthorized
      }

      await apiIntercom.Sentry.GetTabletsList(params).then(res => {
        let tempData = []
        tempData = res.data.Data.Tablets
        tempData.forEach(item => {
          item.IsOpened = item.IntercomTotal > 0 ? '已開通' : '未開通'
        })
        this.totalTablet = tempData.length

        if (this.filter.type) {
          tempData = tabletSort(tempData)
          this.ListData = tempData
          this.loading = false
          return
        }

        const childArr = tempData.filter(el => el.ParentId) // 承租戶
        let fatherArr = tempData.filter(el => !el.ParentId) // 區權戶

        // 把資料整理成element ui要的格式，已顯示樹狀table
        childArr.forEach(el => {
          const fatherIndex = fatherArr.findIndex(item => item.TabletId === el.ParentId)
          if (fatherIndex !== -1) {
            if (fatherArr[fatherIndex].children) {
              fatherArr[fatherIndex].children.push(el)
            } else {
              fatherArr[fatherIndex].children = [el]
            }
          } else {
            fatherArr.push(el)
          }
        })

        // 先排序區權戶
        fatherArr = tabletSort(fatherArr)
        fatherArr.forEach(el => {
          // 再把底下承租戶排序一下
          if (el.children) {
            el.children = tabletSort(el.children)
          }
        })
        this.ListData = fatherArr
        this.loading = false
      }).catch(err => {
        console.log(err)
      })

      // 後端給的資訊：排序依據 Sort->Floor->Rm->TabletId
      function tabletSort (tempData) {
        tempData.sort((a, b) => {
          if (a.Sort !== b.Sort) {
            return a.Sort - b.Sort
          } else if (a.Floor !== b.Floor) {
            return a.Floor - b.Floor
          } else if (a.Rm !== b.Rm) {
            return a.Rm - b.Rm
          } else if (a.TabletId !== b.TabletId) {
            return Number(a.TabletId) - Number(b.TabletId)
          }
          return 0
        })
        return tempData
      }
    },
    openDetailDialog (id) {
      this.detailDialogVisible = true
      this.loading = true
      apiIntercom.Sentry.GetTabletsDevicesV2(id).then(res => {
        console.log(res)
        this.DeviceListData = res.data.Data.Devices
        this.VoipDeviceListData = this.sortVoipDeviceList(res.data.Data.VoipDevices)
        console.log(res)
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    sortVoipDeviceList (sourceList) {
      if (Array.isArray(sourceList)) {
        sourceList.sort((a, b) => {
          const preAreaFirstCharIsNumber = /^\d/.test(a.Area)
          const nextAreaFirstCharIsNumber = /^\d/.test(b.Area)
          if (preAreaFirstCharIsNumber && nextAreaFirstCharIsNumber) return a.Area > b.Area ? -1 : 1
          if (!preAreaFirstCharIsNumber && !nextAreaFirstCharIsNumber) return a.Area < b.Area ? -1 : 1
          if (preAreaFirstCharIsNumber) return -1
          return 1
        })
      }
      return sourceList
    },
    openTransferNumberDialog (id, cellPhoneData, landlineData, tabletId) {
      if (cellPhoneData) {
        this.transferNumber.type = 'phone'
        this.transferNumber.phoneNumber = cellPhoneData.PhoneNumber
      } else if (landlineData) {
        this.transferNumber.type = 'tel'
        this.transferNumber.areaNumber = landlineData.AreaCode
        this.transferNumber.telNumber = landlineData.LandlineNumber
      }
      this.transferNumber.id = id
      this.transferNumber.tabletId = tabletId
      this.transferNumberDialogVisible = true
    },
    async confirmTransferNumber () {
      if (this.transferNumberBtnDisabled) return
      let errorMessage = ''
      const transferErrorHandler = (error) => {
        errorMessage = error?.response?.data?.ErrorMessage?.Description ? error.response.data.ErrorMessage.Description : '號碼儲存失敗'
      }
      console.log(this.transferNumber)
      if (this.transferNumber.type === 'phone') {
        const requestData = { PhoneNumber: this.transferNumber.phoneNumber }
        await apiIntercom.Sentry.PutCallForwardingCellPhone(this.transferNumber.tabletId, requestData).catch(transferErrorHandler)
      } else if (this.transferNumber.type === 'tel') {
        const requestData = { AreaCode: this.transferNumber.areaNumber, LandlineNumber: this.transferNumber.telNumber }
        await apiIntercom.Sentry.PutCallForwardingLandline(this.transferNumber.tabletId, requestData).catch(transferErrorHandler)
      }
      if (errorMessage === '') {
        this.$message({
          message: '號碼儲存成功',
          type: 'success'
        })
        this.getList()
      } else {
        this.$message({
          message: errorMessage,
          type: 'warning'
        })
      }
      this.transferNumberDialogVisible = false
      this.clearTransferNumber()
    },
    clearTransferNumber () {
      this.transferNumber.id = ''
      this.transferNumber.type = ''
      this.transferNumber.areaNumber = ''
      this.transferNumber.telNumber = ''
      this.transferNumber.phoneNumber = ''
    },
    deleteTransferNumber (id) {
      this.$confirm('確認要刪除轉接號碼嗎？', {
        confirmButtonText: '刪除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        console.log('刪除', id)
        await apiIntercom.Sentry.DeleteSubscriberCallForwarding(id).then(() => {
          this.$message({
            message: '號碼已刪除',
            type: 'success'
          })
          this.getList()
        }).catch((error) => {
          let errorMessage = '切換失敗'
          if (error?.response?.data?.ErrorMessage?.Description) errorMessage = error.response.data.ErrorMessage.Description
          this.$message({
            message: errorMessage,
            type: 'warning'
          })
        })
        this.getList()
      }).catch(() => {
        console.log('取消')
      })
    },
    isCorrectTelNumber (number) {
      const totalLength = number.length + this.transferNumber.areaNumber.length
      if (totalLength > 12 || totalLength < 7) return false
      return /^[1-9]\d+$/.test(number)
    },
    isCorrectAreaNumber (number) {
      return /^0[1-8][1-9]{0,2}$/.test(number)
    },
    isCorrectPhone (number) {
      return isValidCellphone(number)
    },
    getdeviceOpenedRate () {
      const tabletCount = this.ListData.length
      let deviceOpenedCount = 0
      this.ListData.forEach(item => {
        if (item.IntercomTotal > 0) {
          deviceOpenedCount++
        }
      })
      this.deviceOpenedRate = deviceOpenedCount / tabletCount ? (deviceOpenedCount / tabletCount * 100).toFixed(2) : null
    },
    closeTransferNumberDialog () {
      this.clearTransferNumber()
    },
    // 若提供部分銷售，則需增加一個「授權狀態」filter
    addPartialSaleFilter () {
      if (!this.contract.partialSale) return
      this.depositFilter.push({
        label: '使用授權',
        name: 'isAuthorized',
        type: 'select',
        options: [
          {
            label: '請選擇',
            value: ''
          },
          {
            label: '已授權',
            value: true
          },
          {
            label: '未授權',
            value: false
          }
        ],
        value: ''
      })
    },
    importNumberFileChange (e) {
      const file = e.target.files[0]
      const type = getExtensionFromLink(file.name)
      if (type !== '.xlsx') {
        this.$message({
          message: '檔案格式錯誤',
          type: 'warning'
        })
        return
      }
      this.importNumberFile = file
    },
    importNumberFileRemove () {
      this.clearNumberFileInput()
    },
    async importNumberFileExportForm () {
      const config = {
        responseType: 'blob'
      }
      try {
        const res = await apiIntercom.Sentry.GetCallForwardingNumberExcel(config)
        createDownloadFile(res)
      } catch (e) {}
    },
    async importNumberFileConfirmUpload () {
      if (!this.importNumberFile || !this.importNumberFile.name || !this.importNumberFile.size) {
        this.$message({
          message: '請選擇檔案',
          type: 'warning'
        })
        return
      }
      const uploadFormData = new FormData()
      uploadFormData.append('File', this.importNumberFile)
      this.importNumberFileProgress = 0
      const importConfig = {
        onUploadProgress: (progressEvent) => {
          this.importNumberFileProgress = parseInt(progressEvent.loaded / progressEvent.total * 100)
        },
        metadata: {
          userHandlesErrors: true
        }
      }
      try {
        await apiIntercom.Sentry.PostCallForwardingNumberExcel(uploadFormData, importConfig)
        this.$message({
          message: '匯入成功',
          type: 'success'
        })
        this.importNumberDialogVisible = false
        this.getList()
      } catch (e) {
        // 400004: 無效的對講機轉接號碼Excel(例如亂改隱藏的id)
        // 400005: 對講機轉接號碼Excel驗證失敗(例如未選擇類型、號碼格式錯誤)
        const errCode = e.response.data.ErrorMessage.Code
        if (errCode === 400005) {
          const errList = e.response.data.Data.ErrorMessages
          if (!e.response.data.Data.MoreThanTenErrors) {
            this.$alert(`以下資料格式有誤，請修改後重新上傳 <br>
              ${errList.join('<br>')}
              `, '檔案資料有誤！！', {
              dangerouslyUseHTMLString: true,
              callback: action => {}
            })
          } else {
            this.$alert(`以下資料格式有誤，請修改後重新上傳 <br>
            ${errList.join('<br>')}<br>...<br><br>錯誤筆數已超過10筆，請確認資料格式後再重新上傳`, '檔案資料有誤！！', {
              dangerouslyUseHTMLString: true,
              callback: action => {}
            })
          }
        } else {
          this.$alert('請先點選「匯出表單」下載範本，填寫完成後再重新上傳', '無效的檔案', {
            callback: action => {}
          })
        }
      }
      this.clearNumberFileInput()
    },
    clearNumberFileInput () {
      this.$refs.invisibleFileInput.value = null
      this.importNumberFile = { name: '' }
      this.importNumberFileProgress = 0
      this.importNumberFileProgress = null
    }
  }
}
</script>
<style lang="sass" scoped>
.tooltip-href
  color: unset
  text-decoration: underline

#residentOpen
  text-align: center
  padding: 20px 0 10px
  height: 100%
  ::v-deep .el-dialog__wrapper
    overflow: hidden
  ::v-deep .el-dialog
    +basicDialog
    overflow: auto
    max-height: 80%
  .devices-table-title
    font-size: map-get($fontSize, small)
    font-weight: 600
    text-align: left
    color: $fontColor
  .newslist
    font-size: 15px
    margin-top: 8px
    .is-authorized
      color: $mainColor
    .not-authorized
      color: $dangerColor
    ::v-deep .el-table
      +basicTable
    .transfer-number
      cursor: pointer
      color: $mainColor
      text-decoration: underline
      text-underline-offset: 3px
    .delete-transfer-number
      cursor: pointer
      margin-left: 3px
    .icon-check-circle
      color: $correctColor
    .icon-filled-info
      color: $SystemYellow

  .center-block
    display: flex
    align-items: center
    margin-top: 20px
  .text-opened
    color: $mainColor
  .text-notOpened
    color: $dangerColor

  ::v-deep .el-dialog
  border-radius: 8px
  .el-dialog__header
    .dialog-title
      font-size: 25px
      font-weight: bold
      margin-bottom: 7px
    .dialog-subTitle
      font-size: 15px
      color: #666666
      padding-top: 3px
  .transfer-number-body
    .el-form
      align-items: center
      .el-form-item
        width: unset
        margin: unset
    .el-select
      min-width: 160px
      max-width: 160px
      margin-right: 10px
    .el-input
      margin-right: 10px
    span
      margin-right: 10px
    .area-number
      max-width: 80px
    .number
      max-width: 250px

  .import-number-dialog
    ::v-deep .el-input__inner
      pointer-events: none
    .upload-text
      color: $subFontColor
    .button-container
      margin-top: 1.5rem
    ::v-deep .el-input__inner
      padding-left: 75px
    ::v-deep .el-input__prefix
      padding-left: 50px
    .progress-text
      margin-top: 0.5rem

  /* 改區權戶收壟的箭頭icon */
  ::v-deep .el-table__expand-icon
    .el-icon-arrow-right
      -webkit-transform: rotate(90deg)
      transform: rotate(90deg)
  ::v-deep .el-table__expand-icon--expanded
    .el-icon-arrow-right
      -webkit-transform: rotate(-90deg)
      transform: rotate(-90deg)

  .el-table::v-deep .el-icon-arrow-right:before
    content: "\e78f"
    font-size: 25px

  .el-table::v-deep .el-table__expand-icon--expanded
    .el-icon-arrow-right:before
      content: "\e790"
      font-size: 25px

  .icon-disable
    opacity: 0.3
    cursor: not-allowed
</style>
